"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var actor_query_operation_union_1 = require("@comunica/actor-query-operation-union");

var bus_query_operation_1 = require("@comunica/bus-query-operation");

var data_model_1 = require("@rdfjs/data-model");

var asynciterator_union_1 = require("asynciterator-union");
/**
 * A comunica Describe Subject Query Operation Actor.
 */


var ActorQueryOperationDescribeSubject =
/*#__PURE__*/
function (_bus_query_operation_) {
  _inherits(ActorQueryOperationDescribeSubject, _bus_query_operation_);

  function ActorQueryOperationDescribeSubject(args) {
    _classCallCheck(this, ActorQueryOperationDescribeSubject);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationDescribeSubject).call(this, args, 'describe'));
  }

  _createClass(ActorQueryOperationDescribeSubject, [{
    key: "testOperation",
    value: function () {
      var _testOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(pattern, context) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", true);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function testOperation(_x, _x2) {
        return _testOperation.apply(this, arguments);
      }

      return testOperation;
    }()
  }, {
    key: "runOperation",
    value: function () {
      var _runOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(pattern, context) {
        var _this = this;

        var operations, variablePatterns, outputs, quadStream, metadata;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Create separate construct queries for all non-variable terms
                operations = pattern.terms.filter(function (term) {
                  return term.termType !== 'Variable';
                }).map(function (term) {
                  // Transform each term to a separate construct operation with S ?p ?o patterns (BGP) for all terms
                  var patterns = [data_model_1.triple(term, data_model_1.variable('__predicate'), data_model_1.variable('__object'))];
                  patterns.forEach(function (templatePattern) {
                    return templatePattern.type = 'pattern';
                  });
                  var templateOperation = {
                    type: 'bgp',
                    patterns: patterns
                  }; // Create a construct query

                  return {
                    input: templateOperation,
                    template: patterns,
                    type: 'construct'
                  };
                }); // If we have variables in the term list,
                // create one separate construct operation to determine these variables using the input pattern.

                if (operations.length !== pattern.terms.length) {
                  variablePatterns = [];
                  pattern.terms.filter(function (term) {
                    return term.termType === 'Variable';
                  }).forEach(function (term, i) {
                    // Transform each term to an S ?p ?o pattern in a non-conflicting way
                    var patterns = [data_model_1.triple(term, data_model_1.variable('__predicate' + i), data_model_1.variable('__object' + i))];
                    patterns.forEach(function (templatePattern) {
                      return templatePattern.type = 'pattern';
                    });
                    variablePatterns = variablePatterns.concat(patterns);
                  }); // Add a single construct for the variables
                  // This requires a join between the input pattern and our variable patterns that form a simple BGP

                  operations.push({
                    input: {
                      type: 'join',
                      left: pattern.input,
                      right: {
                        type: 'bgp',
                        patterns: variablePatterns
                      }
                    },
                    template: variablePatterns,
                    type: 'construct'
                  });
                } // Evaluate the construct queries


                _context2.next = 4;
                return Promise.all(operations.map(function (operation) {
                  return _this.mediatorQueryOperation.mediate({
                    operation: operation,
                    context: context
                  });
                }));

              case 4:
                _context2.t0 = bus_query_operation_1.ActorQueryOperation.getSafeQuads;
                outputs = _context2.sent.map(_context2.t0);
                // Take the union of all quad streams
                quadStream = new asynciterator_union_1.RoundRobinUnionIterator(outputs.map(function (output) {
                  return output.quadStream;
                })); // Take union of metadata

                metadata = function metadata() {
                  return Promise.all(outputs.map(function (output) {
                    return output.metadata;
                  }).filter(function (m) {
                    return !!m;
                  }).map(function (m) {
                    return m();
                  })).then(actor_query_operation_union_1.ActorQueryOperationUnion.unionMetadata);
                };

                return _context2.abrupt("return", {
                  type: 'quads',
                  quadStream: quadStream,
                  metadata: metadata
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function runOperation(_x3, _x4) {
        return _runOperation.apply(this, arguments);
      }

      return runOperation;
    }()
  }]);

  return ActorQueryOperationDescribeSubject;
}(bus_query_operation_1.ActorQueryOperationTypedMediated);

exports.ActorQueryOperationDescribeSubject = ActorQueryOperationDescribeSubject;